import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=21e9ca8a&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=21e9ca8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e9ca8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21e9ca8a')) {
      api.createRecord('21e9ca8a', component.options)
    } else {
      api.reload('21e9ca8a', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=21e9ca8a&scoped=true&", function () {
      api.rerender('21e9ca8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2COnLxsmvKU4F/JS/comp/PopupDialog.vue"
export default component.exports